var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgCloseForSubmission(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.615,
    height: 18,
    viewBox: "0 0 13.615 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-close-for-submission_svg__cls-1,.kpmg-close-for-submission_svg__cls-4{fill:none}.kpmg-close-for-submission_svg__cls-1{stroke:#009a44;stroke-linecap:round;stroke-width:1.6px;stroke-linejoin:round}.kpmg-close-for-submission_svg__cls-3{stroke:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-close-for-submission_svg__ICN_Inchide_pt__Depunere_Hover",
    "data-name": "ICN_Inchide pt. Depunere_Hover",
    transform: "translate(121 1246.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-close-for-submission_svg__Rectangle_255",
    className: "kpmg-close-for-submission_svg__cls-1",
    "data-name": "Rectangle 255",
    transform: "translate(-121 -1239.876)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.615,
    height: 11.538,
    className: "kpmg-close-for-submission_svg__cls-3",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.015,
    height: 9.938,
    x: 0.8,
    y: 0.8,
    className: "kpmg-close-for-submission_svg__cls-4",
    rx: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-close-for-submission_svg__Rectangle_256",
    className: "kpmg-close-for-submission_svg__cls-1",
    "data-name": "Rectangle 256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.731 0a4.731 4.731 0 014.731 4.731v2.731H0V4.731A4.731 4.731 0 014.731 0z",
    className: "kpmg-close-for-submission_svg__cls-3",
    transform: "translate(-118.923 -1246.338)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.731.8a3.931 3.931 0 013.931 3.931V6.32a.342.342 0 01-.342.342H1.142A.342.342 0 01.8 6.32V4.731A3.931 3.931 0 014.731.8z",
    className: "kpmg-close-for-submission_svg__cls-4",
    transform: "translate(-118.923 -1246.338)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-close-for-submission_svg__Group_706",
    "data-name": "Group 706",
    transform: "rotate(180 -56.246 -615.823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-close-for-submission_svg__Ellipse_164",
    className: "kpmg-close-for-submission_svg__cls-1",
    "data-name": "Ellipse 164",
    transform: "translate(0 2.795)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.677,
    cy: 1.677,
    r: 1.677,
    className: "kpmg-close-for-submission_svg__cls-3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.677,
    cy: 1.677,
    r: 0.877,
    className: "kpmg-close-for-submission_svg__cls-4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-close-for-submission_svg__Line_82",
    d: "M1.677 0v3.354",
    "data-name": "Line 82",
    stroke: "#009a44",
    strokeLinecap: "round",
    strokeWidth: 1.6,
    fill: "none"
  })))));
}

export default SvgKpmgCloseForSubmission;